export { Tags as TagsPage } from './Tags';
